<template>

</template>

<script>

export default {
    name: 'RegDevice',
    head: {
        title: 'Registration device redirect | Fine Wine Trading App',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
            }
        ],
        bodyAttrs: {
            class: 'page-reg-success'
        }
    },
    props: {
        navigation: {
            type: Object
        }
    },
    methods: {
        getMobileOperatingSystem() {
            window.location.replace('vindome://regv1');
            setTimeout(() => {
                this.$router.push(this.localePath({ path: '/registration-success' }));
            }, 1000);
        }
    },
    mounted() {
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            this.getMobileOperatingSystem();
        } else {
            this.$router.push(this.localePath({ path: '/registration-success' }));
        }
    }
}
</script>

<style scoped>

</style>

<style>
.page-reg-success .header-toolbar-not-logged,
.page-reg-success .main-footer {
    display: none;
}
</style>
